/* eslint-disable react/jsx-handler-names */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import React, { useState, useRef, useContext } from 'react';

import classNames from 'classnames';
import useOptions from '../useOptions';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import { JobsContext } from '../../../context/JobsContext';
import classes from './styles.module.scss';

export default function DotMenu({
  jobApplication,
  refetch,
  changeJobApplicationStatus,
  interview,
  editCandidate,
  variant,
  candidate = null,
  onOpenChange,
}) {
  const [isOptionsListVisible, setIsOptionsListVisible] = useState(false);

  const hideOptionsOnClick = (event, action) => {
    event.stopPropagation();
    if (action) {
      action();
    }
    setIsOptionsListVisible(false);
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  const dropdownRef = useRef();
  useOnClickOutside(dropdownRef, hideOptionsOnClick);

  const { showAssessmentModal } = useContext(JobsContext);

  const { options, isOnlyStandardOptions, standardOptions } = useOptions({
    jobApplication,
    refetch,
    setIsOptionsListVisible,
    showAssessmentModal,
    changeJobApplicationStatus,
    interview,
    editCandidate,
    candidateId: candidate?.id,
  });

  let optionsToShow = options[jobApplication?.status]?.[
    jobApplication?.subStatus
  ]
    ?.flat()
    ?.filter((option) => !option.hidden && !Array.isArray(option));

  if (!optionsToShow?.length) {
    optionsToShow = standardOptions;
  }

  const hasOnlyStandardOptions = isOnlyStandardOptions(optionsToShow);

  return (
    <div
      ref={dropdownRef}
      className={classNames(classes.dotMenu, {
        [classes.active]: isOptionsListVisible,
        [classes.small]: variant === 'small',
        [classes.medium]: variant === 'medium',
      })}
      onClick={(e) => {
        e.stopPropagation();
        e.nativeEvent?.stopImmediatePropagation();
        setIsOptionsListVisible((prevState) => {
          const newState = !prevState;
          if (onOpenChange) {
            onOpenChange(newState);
          }
          return newState;
        });
      }}
    >
      <div className={classes.selector}>
        {variant === 'small' || variant === 'medium' ? (
          <svg
            width="14"
            height="5"
            viewBox="0 0 14 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="2" cy="2.57812" r="1.5" fill="#242833" />
            <circle cx="7" cy="2.57812" r="1.5" fill="#242833" />
            <circle cx="12" cy="2.57812" r="1.5" fill="#242833" />
          </svg>
        ) : (
          <svg
            width="16"
            height="5"
            viewBox="0 0 16 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="2" cy="2.57812" r="2" fill="#242833" />
            <circle cx="8" cy="2.57812" r="2" fill="#242833" />
            <circle cx="14" cy="2.57812" r="2" fill="#242833" />
          </svg>
        )}
      </div>
      {isOptionsListVisible && optionsToShow?.length ? (
        <div className={classes.options}>
          <ul
            className={classNames(classes.options, {
              [classes.onlyStandardOptions]: hasOnlyStandardOptions,
            })}
          >
            {optionsToShow
              ?.filter((option) => !option.hidden)
              .map((option) => {
                const hasUpperLine =
                  option.title === 'Share' ||
                  option.title === 'Assign Assessment' ||
                  option.title === 'Send Reminder' ||
                  option.title === 'Re-take Assessment';

                return (
                  <li
                    key={option.title}
                    onClick={option.onClick}
                    className={classNames({
                      [classes.disabled]: option.disabled,
                      [classes.lastItemLine]: hasUpperLine,
                    })}
                  >
                    {option.title}
                  </li>
                );
              })}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
